import React, { ReactElement } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Action, Dispatch } from 'redux';
import { modalClosed } from '../../../components/modal/modalActions';
import AnnouncementModal from '../../../workspace/announcementModal/AnnouncementModal';
import { ModalIds } from '../../../components/modal/modalConstants';

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
    dispatchModalClose: () => dispatch(modalClosed(ModalIds.TABLE_ANNOUNCEMENT)),
});

const connector = connect(null, mapDispatchToProps);

type Props = ConnectedProps<typeof connector> & {
    activeModalId: ModalIds;
    dispatchModalClose: () => void;
};

const TableAnnouncementModal = (props: Props): ReactElement => (
    <AnnouncementModal
        modalName={ModalIds.TABLE_ANNOUNCEMENT}
        videoSrc={require('./table-feature.mp4')}
        primaryText="Tables—now in Milanote 🎉"
        {...props}
    />
);

export default connector(TableAnnouncementModal);
